import {Moment} from 'moment'
import IPickupsService from './IPickupsService'
import {AxiosResponse} from 'axios'
import {IExtraPickupFormBody, IPostEquipmentOrderBody} from './interfaces'
import i18n from '@apps/Shared/translation/i18n'
import {Client} from "@apps/Shared/Services/Axios";
import {clearServerMessage, renderServerMessage} from "@apps/Shared/Utils/ServerMessage";
import {ENDPOINT} from "@apps/Shared/Services/Axios/Api";

class PickupsService implements IPickupsService {
    async GetPickups(start: Moment, end: Moment) {
        let res: AxiosResponse;

        try {
            res = await Client(
                'get',
                `${ENDPOINT.Customer.Pickups(
                    start.format('YYYY-MM-DD'),
                    end.format('YYYY-MM-DD')
                )}`
            );
            clearServerMessage();
        } catch (error: any) {
            console.log(error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }

        return res;
    }

    async SubmitExtraPickup(comment: string) {
        let res: AxiosResponse;

        try {
            res = await Client('post', `${ENDPOINT.Customer.SubmitExtraPickup()}`, {
                comment,
            });
            clearServerMessage();
        } catch (error: any) {
            console.log(error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }

        return res;
    }

    async DownloadPickups(start: Moment, end: Moment, dates: string[]) {
        let res: AxiosResponse;

        try {
            res = await Client(
                'post',
                `${ENDPOINT.Customer.DownloadPickups(
                    start.format('YYYY-MM-DD'),
                    end.format('YYYY-MM-DD')
                )}`,
                dates
            );
            clearServerMessage();
        } catch (error: any) {
            console.log(error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }

        return res;
    }

    async GetEquipment() {
        let res: AxiosResponse;

        try {
            res = await Client('get', `${ENDPOINT.Customer.Equipment()}`);
            clearServerMessage();
        } catch (error: any) {
            console.log(error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }

        return res;
    }

    async SubmitEquipmentOrder(body: IPostEquipmentOrderBody) {
        let res: AxiosResponse;

        try {
            res = await Client('post', `${ENDPOINT.Customer.SubmitEquipmentOrder()}`, body);
            clearServerMessage();
        } catch (error: any) {
            console.log(error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }

        return res;
    }

    async SubmitExtraPickupViaForm(postBody: IExtraPickupFormBody) {
        let res: AxiosResponse;

        try {
            res = await Client(
                'post',
                `${ENDPOINT.Customer.SubmitExtraPickupViaForm()}`,
                postBody
            );
            clearServerMessage();
        } catch (error: any) {
            console.log(error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }

        return res;
    }
}

export default new PickupsService()
